export const common = {
  obsText: {
    'da-DK':
      'OBS! Viste farver kan variere på tværs af skærmtype og enhed. Er du i tvivl, anbefaler vi at bestille en farveprøve eller kontakte os på mail info@hcfarver.dk - Vi hjælper gerne med at finde den helt rigtige farve til dig. Bemærk at tonede varer tages ikke retur.'
  },
  vælgDinFarve: { 'da-DK': 'Vælg din farve' },
  vælgFarve: { 'da-DK': 'Vælg farve' }
} as const
